export type LeftTop = {
  left: number;
  top: number;
};

export const AllowOffScreen = {
  None: 0,
  Left: 1,
  Top: 2,
  Right: 4,
  Bottom: 8
};

export const adjustPosition = (
  lt: LeftTop,
  rect: DOMRect,
  allowOffScreen: number,
  boundaries?: Boundaries
): LeftTop => {
  const viewport = boundaries ?? {
    bottom: 0,
    left: 0,
    right: 0,
    top: 0
  };

  let { left, top } = lt;

  // tslint:disable:no-bitwise
  !(allowOffScreen & AllowOffScreen.Left) && (left = Math.max(viewport.left, left));
  !(allowOffScreen & AllowOffScreen.Right) && (left = Math.min(left, window.innerWidth - viewport.right - rect.width));

  !(allowOffScreen & AllowOffScreen.Top) && (top = Math.max(viewport.top, top));
  !(allowOffScreen & AllowOffScreen.Bottom) &&
    (top = Math.min(top, window.innerHeight - viewport.bottom - rect.height));

  return {
    left,
    top
  };
};

export type Boundaries = {
  left: number;
  top: number;
  bottom: number;
  right: number;
};
